<template>
  <div>
    <el-table ref="tableRef" :data="pageGroups" style="width: 100%">
      <template v-for="col in cols" :key="col.prop">
        <el-table-column
          v-if="col.format"
          :width="col.width"
          :label="col.name"
          :prop="col.prop"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            {{ col.format(scope.row) }}
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="col.prop == 'apps'"
          :width="col.width"
          :label="col.name"
          :prop="col.prop"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <span v-for="(app, index) in scope.row.apps" :key="index">
              <span v-if="index != 0">、</span>
              <span>{{ app.name }}&nbsp;</span>
              <i
                :class="['iconfont', 'icon-' + iconEnum[app.platform - 1]]"
              ></i>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          v-else
          :width="col.width"
          :label="col.name"
          :prop="col.prop"
          :align="col.align || 'left'"
          :sortable="col.sortable || false"
        ></el-table-column>
      </template>

      <el-table-column width="180">
        <template #default="scope">
          <span
            class="button"
            style="font-size: 20px; margin-right: 15px; color: #1f86e4"
            @click="handelEdit(scope.row)"
            ><i class="iconfont icon-bianji1"></i
          ></span>
          <span
            class="button delete"
            style="font-size: 20px"
            @click="handelDelete(scope.row)"
            ><i class="iconfont icon-shanchu"></i
          ></span>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      :total="filterGroups.length"
      :size="page.size"
      :onPageChange="handleChangePage"
    />

    <GroupEdit
      title="编辑群组"
      type="edit"
      ref="editGroupRef"
      key="editGroup"
      @submit-success="reloadUsersAndGroups"
    />
  </div>
</template>

<script setup>
import {
  computed,
  defineProps,
  defineExpose,
  getCurrentInstance,
  reactive,
  ref,
} from "vue";
import { formatmambersList } from "@/Utils/UtilTools";
import { useProjectStore } from "@/Store/ProjectStore";
import { storeToRefs } from "pinia";
import Pagination from "@/Components/Pagination.vue";
import GroupEdit from "./GroupEdit.vue";
import { apiDeleteTestGroup } from "@/Api/AppApi";

const props = defineProps({ filter: String });
defineExpose({ doLayout });

const { appContext } = getCurrentInstance();
const $confirm = appContext.config.globalProperties.$confirm;
const $message = appContext.config.globalProperties.$message;

const projectStore = useProjectStore();
const { currentProjectId, testGroups } = storeToRefs(projectStore);

const page = reactive({
  size: 10,
  current: 0,
});
const match = (s) => s && s.includes(props.filter);
const filterGroups = computed(() => {
  const filter = props.filter;
  if (!filter) {
    return testGroups.value;
  }

  return testGroups.value.filter(
    (g) =>
      match(g.groupname) ||
      g.members?.some((m) => match(m.name) || match(m.email)) ||
      g.apps?.some((m) => match(m.name))
  );
});
const pageGroups = computed(() => {
  const start = page.current * page.size;
  return filterGroups.value.slice(start, start + page.size);
});

const iconEnum = ["apple", "android", "windows", "app-store", "linux"];

const cols = [
  { name: "组名", prop: "groupname" },
  { name: "成员数量", prop: "members.length", align: "center" },
  {
    name: "成员名单",
    prop: "members",
    format: function (row) {
      return formatmambersList(row.members);
    },
  },
  { name: "所属应用", prop: "apps" },
];

const editGroupRef = ref(null);
function handelEdit(row) {
  editGroupRef.value.show({
    groupid: row.groupid,
    groupname: row.groupname,
    appids: row.apps.map((app) => app.appid),
    members: row.members.map((m) => m.name),
  });
}

async function handelDelete(row) {
  try {
    await $confirm("删除该测试组？", "", {
      type: "warning",
      confirmButtonClass: "el-button el-button--danger",
      closeOnClickModal: false,
    });

    const data = {
      projectid: currentProjectId.value,
      groupids: [row.groupid],
    };
    const res = await apiDeleteTestGroup(data);
    if (res.code === 0) {
      reloadUsersAndGroups();
    } else {
      $message.error(res.message);
    }
  } catch (e) {
    // nothing
  }
}

function handleChangePage(p) {
  page.current = p - 1;
}

function reloadUsersAndGroups() {
  projectStore.getTestUsers();
  projectStore.getTestGroups();
}

const tableRef = ref(null);
function doLayout() {
  tableRef.value.doLayout();
}
</script>

<style scoped>
.delete:hover {
  color: #eb3a2c;
}

.button {
  cursor: pointer;
}
</style>
